import * as yup from 'yup';

const requiredString = yup.string().required('specialCollectionForm.error.required');

const validation = yup.object().shape({
  name: requiredString,
  place: requiredString,
  address: yup.object().shape({
    streetNumber: yup.string(),
    streetName: requiredString,
    postalCode: yup.string(),
    city: yup.string(),
  }),
  startDate: yup.date().nullable().required('specialCollectionForm.error.required')
    .typeError('specialCollectionForm.error.required'),
  endDate: yup.date().nullable().required('specialCollectionForm.error.required')
    .typeError('specialCollectionForm.error.required')
    .when('startDate', (startDate, schema) => {
      if (startDate?.length && !startDate[0]) return schema;
      return schema.min(
        startDate,
        'specialCollectionForm.error.endDateBeforeStartDate',
      );
    }),
  description: requiredString,
  publishedDate: yup.date().nullable().required('specialCollectionForm.error.required')
    .typeError('specialCollectionForm.error.required'),
  longitude: yup.string(),
  latitude: yup.string(),
});

export default validation;
